import type { CardStylesConfig } from "@/modules/dashboard/cards/types/branding.types";

import type { UserEntity } from "./user.entity";

export const Provider = {
  BLOQUE: "bloque",
} as const;

export type Provider = (typeof Provider)[keyof typeof Provider];

export const OrganizationStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  SUSPENDED: "suspended",
  PENDING: "pending",
} as const;

export type OrganizationStatus = (typeof OrganizationStatus)[keyof typeof OrganizationStatus];

export interface OrganizationEntity {
  id: string;
  name: string;
  slug?: string;
  email: string;
  phone?: string;
  country?: string;
  status: OrganizationStatus;
  created_by?: UserEntity;
  created_by_user_id: string;
  users?: UserEntity[];
  card_provider?: Provider;
  webhook_urls?: string[];
  webhook_secret?: string;
  /**
   * Set by Coloca admins via an internal endpoint when the org is on a paid plan. Gates the branding page
   * write actions in the dashboard.
   */
  can_customize_card_design?: boolean;
  /** Members reach batch payouts only when Coloca staff enabled it; INTERNAL users always do. */
  payout_batches_enabled?: boolean;
  /** Effective value (the global switch or the organization's own): whether members may pay Bre-B QRs. */
  breb_qr_payments_enabled?: boolean;
  /**
   * Effective value: whether the organization has the card wallet (loading cards from it, withdrawing card
   * balance back to it). Opt-in for crypto cards, always true otherwise. Absent from a backend that predates
   * the opt-in, when every organization had it.
   */
  card_wallet_enabled?: boolean;
  /**
   * Org-level sidebar allow-list. When set, only sections whose id appears in this array are shown to all
   * users of this organization. When null/undefined the user's role-based filters apply without restriction.
   * Values: "home" | "operations" | "analytics" | "cards" | "management"
   */
  allowed_menu_modules?: string[] | null;
  /**
   * Org-level card design (gradient + secondary logo). Lives on the auth payload so every card-listing
   * surface (CardRow, CardTile, CardPreviewVisual) can render the org's chosen design without an extra fetch.
   * Updated by the branding page; refreshed via `thunkInitializeAuth` after saves.
   */
  card_styles_config?: CardStylesConfig | null;
  created_at: Date;
  updated_at: Date;
  deleted_at?: Date;
}
